export default __webpack_public_path__ + "static/media/anoop_details_image.7c7cdb68.png";